"use strict";

import angular from "angular";

import _ from "lodash";

import { User } from "../../gateway/User/User";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { Events } from "../../presentation/services/Events/Events";
import { Features } from "../components/help-center/features";

export class CentralSidenavService {
    constructor(
        $mdSidenav,
        $transitions,
        $rootScope,
        $state,
        AccountingDataService
    ) {
        this.$mdSidenav = $mdSidenav;
        this.$transitions = $transitions;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.AccountingDataService = AccountingDataService;

        this.User = new User();
        this.Events = new Events();

        this.componentId = "sidenavHelpCenter";
        this.centralTabIndex = 0;
        this.centralTabIndexHelper = 2;
        this.count = 0;
        this.user = {};
        this.annoContext = false;

        this.blockOpen = false;

        this.showHelperButton = false;

        this.statesHelperAvailable = [
            {
                tabIndex: 1,
                event: "CentralNovidades"
            },
            {
                state: "nucont.accounting.company.department.accounting.import",
                tabIndex: 2,
                event: "CentralAjuda.Importacao.Contabil"
            },
            {
                state: "nucont.accounting.company.department.accounting.scenarios",
                tabIndex: 3,
                event: "CentralAjuda.Cenario.Contabil"
            },
            {
                state: "nucont.accounting.company.customization.indicators",
                tabIndex: 4,
                event: "CentralAjuda.Customizacao.Indicadores"
            },
            {
                state: "nucont.accounting.company.customization.graphics",
                tabIndex: 5,
                event: "CentralAjuda.Customizacao.Graficos"
            },
            {
                state: "nucont.accounting.company.customization.dashboards",
                tabIndex: 6,
                event: "CentralAjuda.Customizacao.Dsahboards"
            },
            {
                state: "nucont.accounting.company.department.financial.import",
                tabIndex: 7,
                event: "CentralAjuda.Importacao.Financeiro"
            },
            {
                state: "nucont.accounting.company.department.financial.edit",
                tabIndex: 8,
                event: "CentralAjuda.Edicao.Financeiro"
            },
            {
                state:
                    "nucont.accounting.company.department.financial.scenarios",
                tabIndex: 9,
                event: "CentralAjuda.Cenario.Financeiro"
            },
            {
                state: "nucont.accounting.company.parameterizationOnDemand",
                tabIndex: 10,
                event: "CentralAjuda.Parametrizacao.Contabil"
            },
            {
                state: "nucont.accounting.company.department.personnel.import",
                tabIndex: 11,
                event: "CentralAjuda.Importacao.Pessoal"
            },
            {
                state: "nucont.accounting.company.department.personnel.edit",
                tabIndex: 12,
                event: "CentralAjuda.Edicao.Pessoal"
            },
            {
                state: "nucont.accounting.company.department.tax.import",
                tabIndex: 13,
                event: "CentralAjuda.Importacao.Fiscal"
            },
            {
                state: "nucont.accounting.company.department.tax.edit",
                tabIndex: 14,
                event: "CentralAjuda.Edicao.Fiscal"
            },
            {
                state: "nucont.accounting.nps.view.overview",
                tabIndex: 15,
                event: "CentralAjuda.NPS"
            },
            {
                state: "nucont.accounting.integration.serpro",
                tabIndex: 16,
                event: "CentralAjuda.Integracao.SerPro"
            },
            {
                state: "nucont.accounting.reporting-center.automations",
                tabIndex: 17,
                event: "CentralAjuda.Relatorio.Automacoes"
            },
            {
                state: "nucont.accounting.integration.contaazul",
                tabIndex: 18,
                event: "CentralAjuda.Integracoes.ContaAzul"
            }
        ];

        this._initListenerTransitionsHelperButton();

        this.$mdSidenav("sidenavHelpCenter", true).then((instance) => {
            instance.onClose(() => {
                this.$rootScope.$broadcast("ON_STOP_YT_PLATER");
            });
        });
    }

    open(tabIndex) {
        if (this.blockOpen) return;

        if (this.annoContext) this.hideTour();

        this._sendEvents(tabIndex);
        this.setCentralTabIndex(tabIndex);

        setTimeout(() => {
            this.$mdSidenav(this.componentId).open();
        }, 200);
    }

    close() {
        this.$mdSidenav(this.componentId).close();

        this.setCentralTabIndex(0);

        this.$rootScope.$broadcast("ON_STOP_YT_PLATER");
    }

    toggle(tabIndex) {
        this.setCentralTabIndex(tabIndex);

        this.$mdSidenav(this.componentId).toggle();
    }

    setCentralTabIndex(tabIndex = 0) {
        this.centralTabIndex = tabIndex;
    }

    setFeaturesCount() {
        const user = new UserDataAdapter().user();

        const flags = Features.list.map((f) => f.flag);

        const userFlags = user.profile.featureFlag;

        if (!userFlags) return (this.count = 0);

        const flagsToUpdate = flags.filter((flag) => {
            return userFlags[flag] !== 1;
        });

        this.count = flagsToUpdate.length;
    }

    setUser(user) {
        this.user = user;
    }

    setCount(count) {
        this.count = count;
    }

    toggleHelperButton() {
        this.showHelperButton = !this.showHelperButton;
    }

    setShowHelperButton(toggle) {
        this.showHelperButton = toggle;
    }

    setCentralTabIndexHelper(tabIndex) {
        this.centralTabIndexHelper = tabIndex;
    }

    _initListenerTransitionsHelperButton() {
        this.checkState(this.$state.current?.name);
        this.$transitions.onStart({}, (transition) => {
            this.checkState(transition.to().name);
        });
    }

    checkState(stateName) {
        const stateAvailable = this.statesHelperAvailable.find(
            (s) => s.state === stateName
        );
        if (stateAvailable) {
            this.setCentralTabIndexHelper(stateAvailable.tabIndex);
            this.setShowHelperButton(true);
        } else this.setShowHelperButton(false);
    }

    async _updateFlagOnboarding(flag) {
        const accounting = this.AccountingDataService.getEntity();
        const response = await this.User.saveMany(accounting.props._id, [
            { _id: this.user._id, featureFlag: flag }
        ]);
    }

    _sendEvents(tabIndex) {
        const state = this.statesHelperAvailable.find(
            (s) => s.tabIndex === tabIndex
        );

        if (_.get(state, "event")) this.Events.send(state.event);
    }

    startTour(module, afterFinish) {
        const user = new UserDataAdapter().user();
        if (
            user?.profile?.featureFlag?.onboarding?.[module] === 1 ||
            user?.profile?.featureFlag?.[module]
        ) {
            if (afterFinish) {
                afterFinish(false);
            }
            return false;
        }

        this._updateFlagOnboarding(module);

        if (this.annoContext) return;

        this.annoContext = new Anno([
            {
                target: "#HelpCenterButtonComponent",
                position: "center-left",
                content:
                    "Surgiu alguma dúvida? Clique na ajuda e veja o conteúdo que preparamos",
                buttons: [],
                onHide: (anno, $target, $annoElem, handler) => {
                    if (afterFinish) {
                        afterFinish(false);
                    }
                    this.annoContext = false;
                }
            }
        ]);

        setTimeout(() => {
            this.annoContext.start();
        }, 3000);

        return true;
    }

    hideTour() {
        this.annoContext.hide();
        this.annoContext = false;
    }
}

angular
    .module("nucont.shared")
    .service("CentralSidenavService", [
        "$mdSidenav",
        "$transitions",
        "$rootScope",
        "$state",
        "AccountingDataService",
        CentralSidenavService
    ]);
